export { default } from "./NoDealsOrPromos";
